import { render, staticRenderFns } from "./GroupInsuranceKeyManDataTable.vue?vue&type=template&id=5e50f13c&scoped=true"
import script from "./GroupInsuranceKeyManDataTable.vue?vue&type=script&lang=js"
export * from "./GroupInsuranceKeyManDataTable.vue?vue&type=script&lang=js"
import style0 from "./GroupInsuranceKeyManDataTable.vue?vue&type=style&index=0&id=5e50f13c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e50f13c",
  null
  
)

export default component.exports